module.exports = __webpack_public_path__ + "static/media/privacy-zh-hant.d3a52e82.md";